import { useNavigate } from '@remix-run/react'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { Button } from '#app/shared/ui/inputs/button/Button.tsx'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.js'

type Props = {}

const CERTIFICATIONS_DATA = [
  {
    title: 'Kilometraje verificado al detalle',
    description:
      'Garantía total sobre la procedencia y el kilometraje real de cada vehículo, revisado y validado en exhaustivamente.',
    imageSrc: '/img/shield-dollar (2).png',
  },
  {
    title: 'Vehículos en estado óptimo',
    description:
      'Revisión y reacondicionamiento exhaustivo, tanto mecánico como estético, para garantizar condiciones impecables en cada coche.',
    imageSrc: '/img/award-03 (2).png',
  },
  {
    title: '14 días o 1.000 kilómetros para probarlo',
    description:
      'Si no cumple tus expectativas, puedes devolverlo y recibirás el 100% de tu dinero.',
    imageSrc: '/img/shield-tick (2).png',
  },
  {
    title: 'Aceptamos tu vehículo como parte de pago',
    description:
      'Tasación competitiva y transparente para descontar el valor de tu coche en la compra.',
    imageSrc: '/img/car-01 (2).png',
  },
] as const

export default function Checked({}: Props) {
  const navigate = useNavigate()
  return (
    <MainContainer>
      <Spacer
        size="36px"
        className={`
          block

          md:hidden
        `}
      />
      <div className="flex items-center">
        <p
          className={`
            text-h5-bold font-bold leading-5 text-neutral-900

            lg:text-h3
          `}
        >
          Por qué somos tu elección óptima.
        </p>
      </div>
      <div
        className={`
          mt-7 flex flex-col items-center justify-center gap-4

          md:flex-row
        `}
      >
        <div className="max-w-[432px] rounded-lg bg-bg-gradient">
          <div
            className={`
              mx-16 mb-[25px] mt-[58px] flex flex-col items-center
              justify-center gap-6
            `}
          >
            <p className="text-center text-h3 text-white">
              Calidad y confianza en cada kilometro.
            </p>
            <Button
              variant={'outlineInput'}
              onClick={() => navigate('/sobre-nosotros')}
              className={`text-white`}
            >
              Conocenos
            </Button>
          </div>
          <div className="flex w-full justify-center">
            <img src="./img/isologo.png" alt="Logo" />
          </div>
        </div>
        <div
          className={`
            grid grid-cols-1 gap-4

            md:grid-cols-2
          `}
        >
          {CERTIFICATIONS_DATA.map((item, index) => (
            <div
              key={index}
              className={`
                flex min-h-[150px] items-center gap-x-[18px] rounded-lg bg-white
                px-5 py-[34px]

                md:max-w-[432px]
              `}
            >
              <div className="flex h-full items-start pt-3">
                {' '}
                <div
                  className={`
                    flex min-h-10 min-w-10 items-center justify-center
                    rounded-full bg-primary-50
                  `}
                >
                  <img src={item.imageSrc} className="h-7 w-7" alt="Logo" />
                </div>
              </div>
              <div>
                <p
                  className={`
                    mb-3 text-base-bold

                    lg:text-h5-bold
                  `}
                >
                  {item.title}
                </p>
                <p className="text-subtitle1-medium text-neutral-600">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Spacer size="20px" />
    </MainContainer>
  )
}
